import { memo } from 'react';

import { FieldBlock } from 'UIPackage/FormModule/components/FieldBlock';
import { getResultDecisionActId } from 'KnmErknmPackage/MainModule/constants/knmErknmFieldsElementsIds';
import { generateOrganizationTemplateText } from 'KnmErknmPackage/MainModule/common/generateOrganizationTemplateText';
import { TextInput } from 'UIPackage/MainModule/components/TextInput';
import { IDecisionOrganizationForm } from 'DecisionPackage/MainModule/interfaces/IDecisionOrganizationForm';
import { Hint } from 'CorePackage/MainModule/components/Hint';

import styles from './DecisionResultItemContentActs.module.scss';

interface IDecisionResultItemContentActsProps {
  resultDecisionId: string;
  organization: IDecisionOrganizationForm | undefined;
}

export const DecisionResultItemContentActs = memo(
  ({ resultDecisionId, organization }: IDecisionResultItemContentActsProps) => {
    return (
      <FieldBlock label={'Акт'} className={styles.GroupMarginBottom}>
        <FieldBlock id={getResultDecisionActId(resultDecisionId)}>
          <TextInput
            disabled={true}
            value={`${organization?.act?.numberAct} - ${generateOrganizationTemplateText(
              organization?.inn || undefined,
              organization?.ogrn || undefined,
              organization?.originalName || undefined,
              organization?.rafpNza || undefined,
            )}`}
          />
        </FieldBlock>
        <Hint text="Выбор акта возможен только после внесения сведений об уведомлении об акте" />
      </FieldBlock>
    );
  },
);
